interface IconBtnProps {
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
  /** Screen-reader name for an icon-only control; the icon itself says nothing. */
  ariaLabel?: string;
  disabled?: boolean;
  /** "span" for an icon inside a link, so the link stays the only focusable element. */
  as?: "button" | "span";
}

const IconBtn: React.FC<IconBtnProps> = ({
  children,
  className,
  onClick,
  ariaLabel,
  disabled,
  as = "button"
}) => {
  const classes = `${className ?? ""} transition-colors hover:bg-gray-200 cursor-pointer
       rounded-full flex items-center justify-center w-8 h-8 select-none bg-transparent border-0 p-0
       disabled:opacity-50 disabled:cursor-not-allowed`;
  if (as === "span") return <span className={classes}>{children}</span>;
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={classes}
    >
      {children}
    </button>
  );
};

export default IconBtn;
